import React from "react";
import PropTypes from "prop-types";
import { cropNumber } from "../../../../common/helpers/helpers";
import { SingleWithLabelAndHelpText } from "../../../../components/atoms";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import { renderVerdict } from "./helpers";
import { dominoItemsFirstRow, dominoItemsSecondRow } from "./constants";
import HelperText from "../../../../components/atoms/HelperText";

const UnilDomino = ({ data }) => {
  if (data && Object.keys(data || {}).length > 0) {
    const content = (
      <div className="varsome-inner-container" data-testid="domino-component">
        <div className="varsome-horiz-flex">
          <div className="varsome-horiz-list-item">
            <div className="varsome-horiz-list-label">
              Probability of AD
              <HelperText fieldDescriptionKey="Probability of AD" />
            </div>
            <div className="varsome-horiz-list-value">
              <b>{cropNumber(data.probability_of_ad)}</b>
            </div>
            {renderVerdict(data.probability_of_ad)}
          </div>
          {dominoItemsFirstRow.map((obj) => {
            return (
              <SingleWithLabelAndHelpText
                key={obj.prop}
                item={data}
                prop={obj.prop}
                label={obj.label}
                crop={true}
              />
            );
          })}
        </div>
        <div className="varsome-horiz-flex">
          {dominoItemsSecondRow.map((obj) => {
            return (
              <SingleWithLabelAndHelpText
                key={obj.prop}
                item={data}
                prop={obj.prop}
                label={obj.label}
                crop={true}
              />
            );
          })}
        </div>
      </div>
    );

    return (
      <div className="varsome-result-fixed">
        <div className="varsome-container varsome-container__basic">
          <ComponentPanel
            title="Domino"
            version={data?.version}
            url="https://fbm.unil.ch/domino/about.php"
            helperPopup={<HelperText fieldDescriptionKey="Domino" />}
            content={content}
          />
        </div>
      </div>
    );
  }
  return null;
};

UnilDomino.propTypes = {
  data: PropTypes.shape({
    version: PropTypes.string,
    lda_score: PropTypes.number,
    mrna_half_life: PropTypes.number,
    numberdonor_numbersynonymous: PropTypes.number,
    phylop_at_5_prime_utr: PropTypes.number,
    probability_of_ad: PropTypes.number,
    string_combined_score: PropTypes.number,
    string_experimental_score: PropTypes.number,
    string_text_mining_score: PropTypes.number,
    gene: PropTypes.string,
  }),
};

UnilDomino.defaultProps = {
  data: null,
};

export default withErrorGuard(UnilDomino, "UnilDomino", "Domino");
